import { render, staticRenderFns } from "./MergeSceneFile.vue?vue&type=template&id=bed5ee44&scoped=true"
import script from "./MergeSceneFile.vue?vue&type=script&lang=js"
export * from "./MergeSceneFile.vue?vue&type=script&lang=js"
import style0 from "./MergeSceneFile.vue?vue&type=style&index=0&id=bed5ee44&prod&lang=scss"
import style1 from "./MergeSceneFile.vue?vue&type=style&index=1&id=bed5ee44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bed5ee44",
  null
  
)

export default component.exports